import React, { useState } from 'react';

const SubscribeRequiredModal = ({
  isOpen,
  onClose,
  onSubscribeClick,
  title = "You've used today's Free upload",
  message = 'Upgrade to Starter for 25 videos per day at $4.99/month.',
}) => {
  const [isConnectingToStripe, setIsConnectingToStripe] = useState(false);
  const [stripeErrorMessage, setStripeErrorMessage] = useState('');

  if (!isOpen) return null;

  const handleSubscribeClick = async () => {
    if (isConnectingToStripe) return;

    setIsConnectingToStripe(true);
    setStripeErrorMessage('');

    try {
      if (onSubscribeClick) {
        await Promise.resolve(onSubscribeClick());
      }
    } catch (error) {
      console.error('Stripe checkout connection failed:', error);

      setStripeErrorMessage(
        'Unable to connect to Stripe Checkout. Please try again.'
      );

      setIsConnectingToStripe(false);
    }
  };

  const handleCloseClick = () => {
    if (isConnectingToStripe) return;

    setStripeErrorMessage('');

    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/85 px-4 backdrop-blur-md">
      <div className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-cyan-300/20 bg-slate-950 p-6 text-center shadow-2xl shadow-cyan-950/50">
        <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-cyan-300/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-16 h-44 w-44 rounded-full bg-amber-300/10 blur-3xl" />

        <div className="relative z-10">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-cyan-300/25 bg-cyan-400/10 text-3xl shadow-lg shadow-cyan-950/30">
            {isConnectingToStripe ? (
              <span className="h-8 w-8 animate-spin rounded-full border-4 border-cyan-100/25 border-t-cyan-100" />
            ) : (
              '🌊'
            )}
          </div>

          <p className="mt-5 text-xs font-black uppercase tracking-[0.3em] text-cyan-300">
            Starter Plan
          </p>

          <h3 className="mt-2 text-2xl font-black tracking-tight text-white">
            {isConnectingToStripe ? 'Connecting to Stripe Checkout' : title}
          </h3>

          <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-slate-300">
            {isConnectingToStripe
              ? 'Preparing your secure checkout session. You will be redirected in a moment.'
              : message}
          </p>

          <div className="mt-5 rounded-2xl border border-white/10 bg-slate-900/60 p-4 text-left">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-emerald-300">
              Starter includes
            </p>

            <ul className="mt-3 space-y-2 text-sm font-semibold text-slate-200">
              <li>✓ 25 videos per day</li>
              <li>✓ $4.99/month</li>
              <li>✓ Spanish subtitle processing</li>
              <li>✓ Preview and download workflow</li>
            </ul>
          </div>

          {stripeErrorMessage && (
            <div className="mt-5 rounded-2xl border border-rose-300/20 bg-rose-500/10 px-4 py-3 text-sm font-semibold leading-5 text-rose-100">
              {stripeErrorMessage}
            </div>
          )}

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={handleSubscribeClick}
              disabled={isConnectingToStripe}
              className="group relative inline-flex min-h-[48px] items-center justify-center overflow-hidden rounded-2xl border border-cyan-200/70 bg-cyan-300/20 px-5 py-3 text-xs font-black uppercase tracking-[0.16em] text-cyan-50 shadow-lg shadow-cyan-950/40 transition hover:-translate-y-0.5 hover:border-amber-200/80 hover:bg-amber-300/15 disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:translate-y-0"
            >
              <span className="absolute inset-0 translate-x-[-120%] bg-gradient-to-r from-transparent via-cyan-100/20 to-transparent transition duration-700 group-hover:translate-x-[120%]" />

              {isConnectingToStripe ? (
                <span className="relative inline-flex items-center gap-3">
                  <span className="h-5 w-5 animate-spin rounded-full border-2 border-cyan-100/30 border-t-cyan-100" />
                  Connecting
                </span>
              ) : (
                <span className="relative">
                  Upgrade to Starter
                </span>
              )}
            </button>

            <button
              type="button"
              onClick={handleCloseClick}
              disabled={isConnectingToStripe}
              className="inline-flex min-h-[48px] items-center justify-center rounded-2xl border border-white/10 bg-slate-900/70 px-5 py-3 text-xs font-black uppercase tracking-[0.16em] text-slate-300 shadow-lg shadow-slate-950/30 transition hover:-translate-y-0.5 hover:border-slate-300/30 hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0"
            >
              Maybe Later
            </button>
          </div>

          <p className="mt-4 text-xs leading-5 text-slate-500">
            {isConnectingToStripe
              ? 'Do not refresh this page while your checkout session is being created.'
              : 'Secure payment is handled through Stripe Checkout.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscribeRequiredModal;